<ngx-spinner bdColor="rgba(0,0,0,0.4)" name="Container" size="medium" color="#fff" type="ball-clip-rotate-multiple" [fullScreen]="true">
    <p style="color: white"> {{ spinnerText }} </p>
</ngx-spinner>
<router-outlet>
    <!--back-to-top button-->
    <app-back-to-top />
</router-outlet>